// TODO: Fix linterrors and remove eslint-disable
/* eslint-disable no-console */
/* eslint-disable react/prop-types */
/* eslint-disable react/require-default-props */
/* eslint-disable max-lines */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable dot-notation */
/* eslint-disable react/sort-comp */
/* eslint-disable camelcase */
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import i18n from 'i18n-react';
import { cssTransition, toast } from 'react-toastify';
import SweetAlert from 'sweetalert-react';

import APIHandler from 'config/APIHandler';
import DataHandler from 'config/DataHandler';

import 'react-toastify/dist/ReactToastify.css';

import RegisterIndustryVisitor from '../RegisterIndustryVisitor';
import RegisterTrade from '../RegisterTrade';

const Zoom = cssTransition({
  enter: 'zoomIn',
  exit: 'zoomOut',
  duration: [500, 800],
});

export default class Register extends Component {
  constructor(props) {
    super(props);
    this.state = {
      appId: 0,
      popUpMarketing: false,
    };

    this.registerHandler = this.registerHandler.bind(this);
    this.registerHandlerSSO = this.registerHandlerSSO.bind(this);
    this.close = this.close.bind(this);
  }

  componentDidMount() {
    this.setAppId();
  }

  close() {
    this.setState({
      popUpMarketing: false,
    });
  }

  async setAppId() {
    this.setState({ appId: await DataHandler.matchAppId() });
  }

  registerHandler(newAccount = false) {
    const { checkInputValidity, checkInputValidityFields, userInput, setAnim } = this.props;
    const {
      registration_code,
      reg_first_name,
      reg_last_name,
      reg_agency_name,
      reg_zip_code,
      reg_country,
      reg_state,
      reg_city,
      reg_agency_affiliation,
      reg_host_agency_name,
      reg_title,
      reg_agency_business,
      marketing_opt_in,
      opt_in_marketing,
    } = userInput;
    if (checkInputValidity()) {
      setAnim('loadingAnimRegister', true);
      let marketing = false;
      if (marketing_opt_in === 'on' || marketing_opt_in === true || marketing_opt_in === 'true') {
        marketing = true;
      }

      let marketing2 = false;
      if (opt_in_marketing === 'on' || opt_in_marketing === true || opt_in_marketing === 'true') {
        marketing2 = true;
      }

      const registerObject = {
        registrationCode: registration_code,
        first_name: reg_first_name,
        last_name: reg_last_name,
        agency_name: reg_agency_name,
        zip_code: reg_zip_code,
        country: reg_country,
        state: reg_state,
        city: reg_city,
        agency_affiliation: reg_agency_affiliation,
        host_agency_name: reg_host_agency_name,
        agency_business: reg_agency_business,
        title: reg_title,
        marketing_opt_in: marketing,
        opt_in_marketing: marketing2,
        email: userInput['reg_email'] || userInput['email'],
        custom_1: 'registered',
      };


      let lang = localStorage.getItem('lang');
      if (lang) {
        lang = JSON.parse(lang);
        lang = lang.rawData;
      } else {
        lang = '';
      }

      const language = lang.code;
      if (language === 'FR-CA') {
        registerObject['country'] = 'caFR';
      }

      const realEmail = userInput['reg_email'] || userInput['email'];
      DataHandler.matchAppId().then(async (appId) => {
        await APIHandler.setUser(this.state.appId, registerObject).then(async () => {
          await APIHandler.getUserOld(appId, realEmail).then((newUser) => newUser);

          const copy = i18n.translate('loginScreen.version2.success');
          const time = 2000;
          // if (newAccount) {
          //   copy = i18n.translate('loginScreen.version2.successNewAccount');
          //   time = 10000;
          // }

          toast.info(`${i18n.translate(copy)}`, {
            position: 'top-center',
            transition: Zoom,
            autoClose: 10000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          });
          setAnim('loadingAnimRegister', false);

          window.setTimeout(() => {
            // Mobile redir
            if (window.location.pathname.includes('mobile')) {
              window.ReactNativeWebView.postMessage('back');
              window.ReactNativeWebView.postMessage('back', '*');
              window.postMessage('back');
              window.postMessage('back', '*');
            }

            window.location.href = '/login';
          }, time);
        });
      });
    } else {
      toast.error(
        `${i18n.translate('loginScreen.version2.errors.fillInAllFields')} ${checkInputValidityFields().join(', ')}`,
        {
          position: 'top-center',
          transition: Zoom,
          autoClose: 10000,
          hideProgressBar: true,
          pauseOnHover: true,
          draggable: true,
        },
      );
      setAnim('loadingAnimRegister', false);
    }
  }

  async registerHandlerSSO(event) {
    const { userInput, setAnim, checkInputValidity, checkInputValidityFields } = this.props;
    const { reg_first_name, reg_last_name, reg_email, reg_agency_name, reg_password, reg_passwordConfirm } = userInput;

    if (
      userInput.opt_in_marketing !== 'on' &&
      userInput.opt_in_marketing !== true &&
      !localStorage.getItem('newsletter')
    ) {
      this.setState({ popUpMarketing: true });

      // Set localStorage to only show once
      localStorage.setItem('newsletter', 'true');
      event.preventDefault();

      setAnim('loadingAnimRegister', false);
      return;
    }

    const submit = event.target;
    submit.disabled = true;
    event.preventDefault();
    setAnim('loadingAnimRegister', true);

    const name = `${reg_first_name} ${reg_last_name}`;
    const email = reg_email || userInput['email'];
    const company = reg_agency_name;
    const password = reg_password;
    const passwordConfirm = reg_passwordConfirm;

    if (window.location.href.includes('quick-register')) {
      // Only do registerHandler call and skip some validation
      this.registerHandler();
      submit.disabled = false;
      return;
    }

    if (password === undefined) {
      toast.error(`${i18n.translate('loginScreen.version2.errors.password')}`, {
        position: 'top-center',
        transition: Zoom,
        autoClose: 10000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
      submit.disabled = false;
      setAnim('loadingAnimRegister', false);
      return;
    }

    if (password !== passwordConfirm) {
      toast.error(`${i18n.translate('loginScreen.version2.errors.passwordNotMatching')}`, {
        position: 'top-center',
        transition: Zoom,
        autoClose: 10000,
        hideProgressBar: true,
        pauseOnHover: true,
        draggable: true,
      });
      submit.disabled = false;
      setAnim('loadingAnimRegister', false);
      return;
    }

    if (password.length < 8) {
      toast.error(`${i18n.translate('loginScreen.version2.errors.passwordTooShort')}`, {
        position: 'top-center',
        transition: Zoom,
        autoClose: 10000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
      submit.disabled = false;
      setAnim('loadingAnimRegister', false);
      return;
    }

    if (checkInputValidity()) {
      await APIHandler.registerSSOUser(name, email, company, password, passwordConfirm).then((SSOUser) => {
        if (SSOUser.success === false) {
          toast.error(`${i18n.translate('loginScreen.version2.errors.emailExists')}`, {
            position: 'top-center',
            transition: Zoom,
            autoClose: 10000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          });
          submit.disabled = false;
          setAnim('loadingAnimRegister', false);
        } else {
          // Old school register
          this.registerHandler(true);
          submit.disabled = false;
        }
      });
    } else {
      toast.error(
        `${i18n.translate('loginScreen.version2.errors.fillInAllFields')} ${checkInputValidityFields().join(', ')}`,
        {
          position: 'top-center',
          transition: Zoom,
          autoClose: 10000,
          hideProgressBar: true,
          pauseOnHover: true,
          draggable: true,
        },
      );
      submit.disabled = false;
      setAnim('loadingAnimRegister', false);
    }
  }

  render() {
    const { userInput, change, loadingAnimRegister, back, passwordField, country, marketing_opt_in, opt_in_marketing } =
      this.props;
    const { popUpMarketing } = this.state;

    return (
      <div className="Register">
        <div className="hidden">
          {marketing_opt_in}
          {opt_in_marketing}
        </div>
        <div className="step mt-1">{i18n.translate('loginScreen.version2.step1')}</div>
        <div className="radioButtons">
          <label htmlFor="agent" className={`${userInput.registration_code === 'agent' ? 'checked' : ''}`}>
            <input
              type="radio"
              value="agent"
              id="agent"
              name="registration_code"
              onChange={change}
              required
              checked={userInput.registration_code === 'agent' ? 'true' : ''}
            />
            {i18n.translate('loginScreen.version2.agent')}
          </label>
          <label htmlFor="visitor" className={`${userInput.registration_code === 'visitor' ? 'checked' : ''}`}>
            <input
              type="radio"
              value="visitor"
              id="visitor"
              name="registration_code"
              onChange={change}
              required
              checked={userInput.registration_code === 'visitor' ? 'true' : ''}
            />
            {i18n.translate('loginScreen.version2.visitor')}
          </label>
        </div>

        <p className="step-title header">
          {userInput.registration_code === 'visitor'
            ? i18n.translate('loginScreen.version2.titleIndustry')
            : i18n.translate('loginScreen.version2.title')}
        </p>

        <div className="step">{i18n.translate('loginScreen.version2.step2')}</div>

        {(userInput.registration_code === '' || userInput.registration_code === 'agent') && (
          <RegisterTrade
            submit={this.registerHandlerSSO}
            change={change}
            loadingAnimRegister={loadingAnimRegister}
            passwordField={passwordField}
            back={back}
            country={country}
            userInput={userInput}
            changeItem={this.props.changeItem}
            defaultVal={this.props.defaultVal}
          />
        )}

        {userInput.registration_code === 'visitor' && (
          <RegisterIndustryVisitor
            submit={this.registerHandlerSSO}
            change={change}
            loadingAnimRegister={loadingAnimRegister}
            passwordField={passwordField}
            back={back}
            country={country}
            userInput={userInput}
            changeItem={this.props.changeItem}
            defaultVal={this.props.defaultVal}
          />
        )}

        <SweetAlert
          title=""
          show={popUpMarketing}
          onConfirm={() => {
            this.props.enableMarketing();
            this.setState({ popUpMarketing: false });
          }}
          text={i18n.translate('loginScreen.version2.marketingOptIn')}
          onCancel={() => {
            console.log('cancel');
            this.setState({ popUpMarketing: false });
          }}
          confirmButtonText={i18n.translate('loginScreen.version2.optIn')}
          cancelButtonText={i18n.translate('loginScreen.version2.optOut')}
          showCancelButton
        />
      </div>
    );
  }
}

Register.propTypes = {
  enableMarketing: PropTypes.func.isRequired,
  changeItem: PropTypes.func.isRequired,
  passwordField: PropTypes.bool,
  back: PropTypes.func.isRequired,
  change: PropTypes.func.isRequired,
  checkInputValidity: PropTypes.func.isRequired,
  checkInputValidityFields: PropTypes.func.isRequired,
  loadingAnimRegister: PropTypes.bool.isRequired,
  setAnim: PropTypes.func.isRequired,
  country: PropTypes.string,
  marketing_opt_in: PropTypes.string,
  opt_in_marketing: PropTypes.string,
  defaultVal: PropTypes.string,
  userInput: PropTypes.shape({
    email: PropTypes.string,
    reg_email: PropTypes.string,
    reg_first_name: PropTypes.string,
    reg_last_name: PropTypes.string,
    reg_zip_code: PropTypes.string,
    reg_country: PropTypes.string,
    reg_state: PropTypes.string,
    reg_agency_name: PropTypes.string,
    reg_password: PropTypes.string,
    reg_passwordConfirm: PropTypes.string,
    registration_code: PropTypes.string,
    marketing_opt_in: PropTypes.bool,
    reg_title: PropTypes.string,
    reg_agency_affiliation: PropTypes.string,
    reg_host_agency_name: PropTypes.string,
    reg_agency_business: PropTypes.string,
    reg_city: PropTypes.string,
    opt_in_marketing: PropTypes.bool,
  }),
};

Register.defaultProps = {
  passwordField: false,
  country: '',
  defaultVal: '',
  userInput: {
    email: '',
    reg_email: '',
    reg_first_name: '',
    reg_last_name: '',
    reg_agency_name: '',
    reg_zip_code: '',
    reg_country: '',
    reg_state: '',
    reg_title: '',
    reg_agency_affiliation: '',
    reg_host_agency_name: '',
    reg_agency_business: '',
    reg_password: '',
    reg_passwordConfirm: '',
    registration_code: '',
    marketing_opt_in: '',
    reg_city: '',
    opt_in_marketing: '',
  },
};
